import {gql} from '@shopify/hydrogen';
import {useQuery} from 'react-query';
import {IQuery} from '~/types';
import {queryBe} from '~/utils';

export function useProductReviews({
  productId,
}: {
  productId: string | undefined;
}) {
  return useQuery(['fetch-product-reviews', productId], {
    queryFn: async () => {
      const res = await queryBe<'reviews', IQuery['reviews']>({
        query: QUERY,
        variables: {
          productId: parseFloat(productId?.split('/').pop() ?? '0'),
        },
      });
      return res;
    },
    cacheTime: 0,
  });
}

const QUERY = gql`
  query reviews($productId: Float) {
    reviews(productId: $productId) {
      id
      title
      body
      rating
      product_external_id
      reviewer {
        id
        external_id
        email
        name
        phone
        accepts_marketing
        unsubscribed_at
        tags
      }
      source
      curated
      hidden
      verified
      featured
      created_at
      updated_at
    }
  }
`;
